var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { DetailServiceSymbol } from '@/services/DetailService';
import _ from 'lodash';
import { service as VXEService } from '@/presentation/components/folders/vxeCells/index';
import advanceSortService from 'library-@/components/advanceSort/service';
import { injectable, inject } from '@/inversify.config';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
import { FolderSettingService } from '@/domains/detail/folder/types/folder-setting-service.interface';
import { E_FIELD_PERMISSION_TYPE } from '@/domains/detail/folder/enums';
const EditCustomFieldDialog = () => import('./src/AiCustomFieldMain.vue');
export { EditCustomFieldDialog };
export const EditAiCustomFieldDialogServiceSymbol = Symbol.for('EditAiCustomFieldDialogService');
let EditAiCustomFieldDialogService = class EditAiCustomFieldDialogService {
    constructor(detailService, spaceService, folderService, folderSettingService) {
        this.detailService = detailService;
        this.spaceService = spaceService;
        this.folderService = folderService;
        this.folderSettingService = folderSettingService;
        ptDialogAutoMounterManager.register(EditCustomFieldDialog);
        this.state = this.getDefState();
    }
    getDefState() {
        return {
            isOpen: false,
            field: null,
            isEdit: false,
            defaultType: 'OPTION',
            toIndex: undefined,
            customFieldList: this.customFieldList,
            isSpaceOwner: this.isSpaceOwner,
            isPublicMode: this.isPublicMode,
        };
    }
    get isSpaceOwner() {
        return _.get(this.spaceService, 'spaceInfo.is_owner');
    }
    get isPublicMode() {
        return _.get(this.spaceService, 'spaceInfo.is_public_space');
    }
    get customFieldList() {
        return _.get(this.detailService, 'custom_fields$', []);
    }
    open(param) {
        this.state = {
            ...this.getDefState(),
            ...this.state,
            ...param,
            isOpen: true,
        };
        ptDialogAutoMounterManager.update(EditCustomFieldDialog, {
            ...this.state,
            folderName: this.folderService.folderInfo.folder_name,
            fields: _.get(this.detailService, 'custom_fields$', []),
            workspaceId: this.detailService.spaceId,
            folderId: this.detailService.folderId,
            sort: this.folderSettingService.folderSetting.current_sort,
            viewType: this.detailService.viewDataType,
            viewMode: this.detailService.viewMode2,
            onCloseHandler: this.close.bind(this),
            onActionHandler: this.onUpdateSettings.bind(this),
            vIf: true,
        });
    }
    close() {
        this.state = this.getDefState();
        this.state.isOpen = false;
        ptDialogAutoMounterManager.toggleOpenState(EditCustomFieldDialog, false);
    }
    onUpdateSettings(field, no_toast = false) {
        const $eventHub = window.Bus;
        // TODO: @Vuex 表格中自定义字段宽度可能引起变动
        // store.commit(COMMENT_CHANGE)
        if (!field)
            return;
        // marked as me
        field.create_by_me = true;
        field.edit_value =
            this.folderService.folderPermission.field_permission_type === E_FIELD_PERMISSION_TYPE.EDIT
                || this.folderService.folderPermission.field_permission_type === E_FIELD_PERMISSION_TYPE.LABEL;
        const customFields = _.get(this.detailService, 'custom_fields$') || [];
        const idx = _.findIndex(customFields, { field_id: field.field_id });
        if (idx !== -1) {
            // @ts-ignore
            const nextField = customFields[idx].user_email
                ? _.assign({}, field, {
                    // @ts-ignore
                    user_email: customFields[idx].user_email,
                })
                : field;
            customFields.splice(idx, 1, nextField);
            $eventHub.$emit('SpaceDetail:ExcelGrid:updateCol', {
                field: nextField,
            });
        }
        else {
            let position = _.findLastIndex(customFields, {
                create_by_me: true,
            });
            if (position === -1) {
                position = _.findLastIndex(customFields, {
                    create_by_owner: true,
                });
            }
            if (position === -1) {
                position = 0;
            }
            else {
                position++;
            }
            if (field.to_index !== undefined) {
                position = field.to_index;
            }
            customFields.splice(position, 0, field);
            $eventHub.$emit('SpaceDetail:ExcelGrid:AddCol', { field });
        }
        if (VXEService.tableInstance) {
            VXEService.clearCustomFieldIdNameMapping(field.field_id);
        }
        $eventHub.$emit('SpaceDetail:LeftRefineTab:RefreshRefine');
        this.detailService.setCustomFields(customFields);
        advanceSortService.update();
    }
};
EditAiCustomFieldDialogService = __decorate([
    injectable(),
    __param(0, inject(DetailServiceSymbol)),
    __param(1, inject(SpaceService)),
    __param(2, inject(FolderService)),
    __param(3, inject(FolderSettingService)),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof SpaceService !== "undefined" && SpaceService) === "function" ? _a : Object, typeof (_b = typeof FolderService !== "undefined" && FolderService) === "function" ? _b : Object, typeof (_c = typeof FolderSettingService !== "undefined" && FolderSettingService) === "function" ? _c : Object])
], EditAiCustomFieldDialogService);
export { EditAiCustomFieldDialogService };
